














































































































































































































































































































import { PropType, defineComponent, computed, ComputedRef, getCurrentInstance } from '@vue/composition-api';
import { Message, ReportData } from '../../../dataType';
import { useLocale } from '../../../hooks/useLocale';
import { useCommonHooks } from './help';
import {
  IntentCodeType,
  ReportDataType,
  CommonType,
  CustomCommonType,
  ProgressCodeType,
  StatisticType,
  ProgressType,
  GroupData
} from './type';
import { useRender } from '../../../hooks/useRender';
import { useConfig } from '../../../hooks/useConfig';
import { useMessage } from '../../../hooks/useMessage';
import AsyncLoading from './async-loading.vue';

export default defineComponent({
  components: {
    AsyncLoading
  },
  props: {
    message: {
      type: Object as PropType<Message<ReportData<any>>>,
      required: true
    }
  },
  setup(props) {
    const { t, tc } = useLocale();
    const instance = getCurrentInstance();
    const showDailyField: Array<('finishWork' | 'inProgressWork' | 'overDueWork') & (keyof ReportDataType)> = ['finishWork', 'inProgressWork', 'overDueWork'];
    const intentCode = props.message.content.report.base.intentCode as IntentCodeType;
    const reportData = computed(() => {
      return props.message.content.report.reportData as ReportDataType;
    });
    const reportType = props.message.content.report.reportType;
    const { addUserTextMessage, robotWaitWithAsyncOperation, sendMessageAndUpdateId } = useMessage();
    const { openAside } = useRender();

    const {
      intentCodeTranslateMap,
      unitTranslateMap,
      transformUnitByStatisticType,
      levelUnit,
      transformIssueText,
      transformListNeedData,
      transformSummaryNeedData
    } = useCommonHooks();
    const fixedTitleMap = intentCodeTranslateMap[intentCode];
    const workStatisticType = computed(() => reportData.value.workStatisticType) as ComputedRef<StatisticType>;
    const listMap = computed(() => {
      const final = showDailyField.filter(
        (key): Boolean => (key === 'finishWork' || reportData.value[key]!?.issueIds?.length > 0)
      );

      return final.map((key): CustomCommonType => {
        const content = (reportData.value?.[key]?.content?.length || 0) > 6 ? reportData.value[key]?.content.slice(0, 6)
          : reportData.value[key]?.content;
        return {
          type: key === 'finishWork' ? 'item' : 'group',
          key,
          ...(reportData.value[key] as CommonType),
          content: content || []
        };
      });
    });
    const openAsideComponent = (
      issueIds: Array<number>,
      type: string,
      hasGroup?: Array<GroupData> | null,
      trackType?: string,
      trackParam?: any
    ) => {
      openAside(() => import('../../aside-component/IssueList.vue'), {
        ...props.message,
        title: `${t('backlog.Sprint')}: ${reportData.value.sprintName} ${t('project.With_this_Date')}: ${reportData.value.reportDate} ${type}`,
        content: {
          issueIds: issueIds,
          loadListById: true,
          hasGroup
        }
      });

      if (trackType) {
        instance?.proxy.$track.send(trackType, trackParam, true);
      }
    };

    const summaryList = computed(() => {
      const o = {
        finish: reportData.value.progress.finish,
        inProgress: reportData.value.progress.inProgress,
        overDue: reportData.value.progress.overDue
      };
      if (reportData.value.progress.overDue.issueCount < 1) {
        Reflect.deleteProperty(o, 'overDue');
      }
      return o;
    }) as ComputedRef<ProgressType>;
    const allSummaryList = computed(() => {
      const keys = Object.keys(reportData.value.progress) as Array<ProgressCodeType>;
      return keys.reduce((acc: number[], key: ProgressCodeType): Array<number> => {
        return [...acc, ...reportData.value.progress[key]?.issueIds];
      }, []);
    });
    const viewRiskDetails = async(event: Event) => {
      const params = {
        id: 0,
        inputText: {
          text: t('saas.robotChat.sprintRiskSearch'),
          push: true,
          save: true
        },
        actionType: 'query_sprint_risk',
        actionJson: {
          riskTitle: props.message.content.report.riskTitle,
          sprintId: reportData.value.sprintId
        }
      };
      const msg = addUserTextMessage(t('saas.robotChat.sprintRiskSearch'));
      robotWaitWithAsyncOperation(() => sendMessageAndUpdateId(msg, 'confirm', params, {
        event: event,
        intent: 'progress',
        parabolaAnimation: true
      }));

      instance?.proxy.$track.send('WebIM_ClickRisk', {
        Intent_Type: intentCode === 'weekly_report' ? '迭代周报' : '迭代日报',
        Risk_Type: '查看风险详情按钮'
      }, true);
    };

    const transformSummaryByStatus = (issue: any) => {
      const array = [{
        title: intentCode === 'weekly_report' ? t('saas.robotChat.hasStatisticsWorksFinishWeek') : t('saas.robotChat.hasStatisticsWorksFinishDay'),
        issueIds: issue.finishIssueIds
      }, {
        title: intentCode === 'weekly_report' ? t('saas.robotChat.hasStatisticsWorksUndoneWeek') : t('saas.robotChat.hasStatisticsWorksUndoneDay'),
        issueIds: issue.unFinishIssueIds
      }];
      return array;
    };

    return {
      t,
      tc,
      reportType,
      reportData,
      intentCode,
      unitTranslateMap,
      transformUnitByStatisticType,
      levelUnit,
      fixedTitleMap,
      listMap,
      openAsideComponent,
      workStatisticType,

      summaryList,
      allSummaryList,
      viewRiskDetails,
      transformIssueText,
      transformSummaryNeedData,
      transformListNeedData,
      transformSummaryByStatus
    };
  }
});
